import { Arguments } from '@dnd-kit/sortable/dist/hooks/useSortable';
import { FC, HTMLAttributes } from 'react';
import { OrderIcon } from '../../assets/svg/order';
import { IconButton } from '../../components/icon-button/icon-button';
import { useSorterItem } from './use-sorter-item';

interface Props extends HTMLAttributes<HTMLDivElement> {
  sortableArgs?: Arguments;
  withSortIcon?: boolean;
  isDisabled?: boolean;
}

export const SortableItem: FC<Props> = (props) => {
  const { sortableArgs, children, className, withSortIcon = true, isDisabled } = props;
  const { sortStyle, setNodeRef, listeners, attributes, isDragging } = useSorterItem(sortableArgs);

  return (
    <div
      className={className}
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      style={{
        ...sortStyle,
        textAlign: 'center',
        cursor: isDragging ? 'grabbing' : 'grab',
        opacity: isDragging ? 0.5 : 1,
      }}
    >
      {withSortIcon && !isDisabled && (
        <IconButton variant="ghost">
          <OrderIcon />
        </IconButton>
      )}
      {children}
    </div>
  );
};
